































































































import { Component, Vue, Prop, Provide } from 'vue-property-decorator'
import MainTemplate from '@/components/MainTemplate.vue'
import { PaperItem, NoBinds } from '@/components'
import { paperDetail, paperDoc, paperDocS2, getPaperListDetail } from './models/api'
import { loadFromLocal } from '@/utils/local'
import TestJeyoo from './../../components/common/testOther/TestJeyoo.vue'
import TestZxxk from './../../components/common/testOther/TestZxxk.vue'
import DownloadModal from './components/DownloadModal.vue'
import Office from './components/Office.vue'
import CmsPreview from './components/CmsPreview.vue'
import PaperPreview from './components/PaperPreview.vue'
import QuestionBus from '../question/components/QuestionBus.vue'
import pdf from './pdf.vue'
import { sa } from '@/utils/sa'

@Component({
  components: {
    MainTemplate,
    PaperItem,
    pdf,
    TestJeyoo,
    TestZxxk,
    DownloadModal,
    NoBinds,
    Office,
    PaperPreview,
    QuestionBus,
    CmsPreview
  }
})
export default class PaperDetail extends Vue {
  public paper = {
    preview_doc_srcs: ''
  }
  public visible = false
  public size = 'large'
  public testModal = false
  public loading = false
  public youDian = {}
  public loadingModal = false
  public currentUrl = ''
  public currentPaper: any = {}
  public isBand = true
  public questions = []
  public loadingPaper = false
  public useRannder = false

  // computed
  public get currentSite() {
    return ~~this.$route.query.site
  }
  public get userName() {
    return this.$store.state.user ? this.$store.state.user.name : undefined
  }
  public get id() {
    return this.$route.query._id
  }
  public get subjectId() {
    return this.$route.query.subject_id
  }
  public get site() {
    return this.$route.query.site
  }
  public get site_name() {
    return this.$route.query.site_name
  }
  public get grade() {
    return this.$route.query.grade
  }
  public get grade_name() {
    return this.$route.query.grade_name
  }
  public get paper_type() {
    return this.$route.query.paper_type
  }
  public get paper_type_name() {
    return this.$route.query.paper_type_name
  }
  public get region_code() {
    return this.$route.query.region_code
  }
  public get region_name() {
    return this.$route.query.region_name
  }
  public get year() {
    return this.$route.query.year
  }
  public get from() {
    return this.$route.query.from || ''
  }
  public get isDownloaded() {
    return this.$route.query.is_downloaded == 'true'
  }
  public get costs() {
    return this.$route.query.costs
  }
  private get userInfo() {
    return this.$store.state.user_info
  }
  private get showExtra() {
    return this.userInfo && this.userInfo.is_inner_user
  }
  // methods
  /**
   * mounted
   */
  public mounted() {
    if (this.userName) {
      this.getData()
      if (this.from === '组卷') {
        // this.getQuestions()
      }
    } else {
      window.location.href = '/search/index'
    }
  }
  public async getQuestions() {
    this.loadingPaper = true
    this.useRannder = true
    let data = await getPaperListDetail({ paper_id: this.id, subject_id: this.subjectId })
    this.loadingPaper = false
    if (data.success) {
      if (data.msg.classification && data.msg.classification.length > 0) {
        this.questions = data.msg.classification
      } else {
        this.useRannder = false
      }
    } else {
      this.useRannder = false
    }
  }
  public judgeRender(val) {
    if (val && val.length) {
      return val.every((item) => {
        return (
          item.indexOf('.zip') !== -1 ||
          (item.substring(item.length - 6).indexOf('.') === -1 && item.indexOf(';base64') === -1) ||
          item.indexOf('.mp3') !== -1 ||
          item.indexOf('.rar') !== -1
        )
      })
    } else {
      return false
    }
  }
  /**
   * judgePics
   */
  public judgePics(item) {
    let whiteList = ['.jpg', '.png', '.gif', '.jpeg', '.svg', ';base64']
    return whiteList.some((val) => {
      return item.includes(val)
    })
  }
  /**
   * judgeOffice
   */
  public judgeOffice(item) {
    let whiteList = ['.doc', '.docx', '.xls', '.xlsx']
    return whiteList.some((val) => {
      return item.includes(val)
    })
  }
  /**
   * track
   */
  public async track() {
    // tslint:disable-next-line
    sa.track('ContentRepository_Download', {
      grade: this.grade,
      grade_name: this.grade_name,
      province: this.region_code,
      province_name: this.region_name,
      year: this.year,
      source: this.paper_type,
      source_name: this.paper_type_name,
      ContentRepository: this.site,
      ContentRepository_name: this.site_name,
      subject_list: [this.subjectId + ''],
      action: '点击下载'
    })
  }
  /**
   * downloadFile
   */
  public async downloadFile(data) {
    // console.log(data)
    // this.getPaperDoc(this.id, data)
    this.track()
    if (this.currentUrl) {
      this.loadingModal = true
      let res = await paperDocS2({
        doc_src: (this.youDian as any).doc_src,
        site: this.currentSite
      })
      this.loadingModal = false
      if (res.code === 0) {
        sa.track('ContentRepository_Download', {
          action: '下载成功'
        })
        window.open(this.currentUrl + `&url=${res.data.doc_src}`)
      } else {
        this.$message.warning('下载地址不见了')
      }
      this.cancelModal()
    } else {
      this.$message.warning('下载地址不见了')
    }
  }
  public downloadInfoChange(val) {
    if (this.visible) {
      this.getPaperDoc(this.currentPaper.id, val)
    }
  }
  /**
   * cancelModal
   */
  public cancelModal() {
    this.visible = false
  }
  /**
   * onTestCancel
   */
  public onTestCancel() {
    this.testModal = false
  }
  /**
   * jeyooLogin
   */
  public jeyooLogin() {
    this.getData()
  }
  /**
   * getData
   */
  public async getData() {
    this.loading = true
    let data = await paperDetail({
      subject_id: this.subjectId,
      paper_id: this.id,
      site: this.currentSite
    })
    this.loading = false
    if (data.success) {
      this.isBand = true
      let paper = Object.assign({}, data.data, {
        is_downloaded: this.isDownloaded,
        costs: this.costs
      })
      paper.id = this.id
      this.paper = paper
      console.log(this.paper)
    } else {
      this.paper = { preview_doc_srcs: '' }
      if (data.error === '请登录') {
        this.$store.commit('SET_LOGINMODAL', true)
      }
      if (data.code === 1) {
        this.$message.warning(data.msg)
      }
      if (data.code === 2) {
        location.href = '/search'
        this.isBand = false
      }
      if (data.code === 3) {
        this.isBand = false
      }
      if (data.code === 4) {
        this.testModal = true
      }
    }
  }
  public async getPaperDoc(val, obj?: any) {
    let req = {
      subject_id: this.subjectId,
      paper_id: val,
      site: this.currentSite
    }
    let res: any = null
    if (obj) {
      req = Object.assign({}, req, obj)
    }
    this.loadingModal = true
    let data = await paperDoc(req)
    this.loadingModal = false
    // console.log(data)
    if (data.error === '请登录') {
      this.cancelModal()
      this.$store.commit('SET_LOGINMODAL', true)
      return
    }
    if (data.code === 4) {
      this.cancelModal()
      this.testModal = true
      return
    }
    if (!data.data.doc_src) {
      if (data.data.msg) {
        this.$message.warning(data.data.msg)
      } else {
        // this.$message.warning('下载地址不见了')
      }
      if (data.data && data.data.remaining_ticket_num >= 0) {
        this.youDian = {
          remaining_ticket_num: data.data.remaining_ticket_num,
          required_ticket_num: data.data.required_ticket_num,
          doc_src: ''
        }
      }
      return
    }
    if (data.data && data.data.remaining_ticket_num >= 0) {
      this.youDian = {
        remaining_ticket_num: data.data.remaining_ticket_num,
        required_ticket_num: data.data.required_ticket_num,
        doc_src: data.data.doc_src
      }
    }
    this.loadingModal = false
    sa.track('ContentRepository_Download', {
      action: '下载成功'
    })
    let temp =
      '/search/finish' + `?subject_id=${this.subjectId}&paper_id=${val}&site=${this.currentSite}`
    if (this.currentSite == 2 && obj.da) {
      this.currentUrl = temp + `&da=${obj.da}&df=${obj.df}&dm=${obj.dm}`
    } else {
      temp = temp + `&url=${data.data.doc_src}`
      window.open(temp)
    }
  }
  /**
   * clickDownload
   */
  public clickDownload(val: any) {
    this.currentPaper = {
      id: this.id,
      name: val.name
    }
    if (!this.userName) {
      location.href = '/search'
      this.$store.commit('SET_LOGINMODAL', true)
      return
    }
    if (this.currentSite === 2) {
      this.visible = true
    } else {
      this.getPaperDoc(this.id, {
        mode: val.mode,
        format: val.format,
        render_mode: val.render_mode,
        with_analysis: val.with_analysis,
        with_answer: val.with_answer,
        with_knowledge_points: val.with_knowledge_points,
        with_paper_origin: val.with_paper_origin
      })
      this.track()
    }
  }
}
